import React from 'react'

import {Select} from '../UI/forms/index.js'
import naturalSortBy from 'src/utils/naturalSortBy.js'

export default class SelectRoute extends React.PureComponent {
    render() {
        const {label, value, usersObject, routes, date, style, onChange, disabled} = this.props

        const options = []

        naturalSortBy(Object.values(routes), (route) => route.name).map((route) => {
            const routeId = route._id

            if ((route.completed && value !== routeId) || (date && route.date !== date)) {
                return
            }

            options.push({value: routeId, title: `${route.name || ''}${(route.name && route.messengerId) ? ' - ' : ''}${usersObject[route.messengerId]?.name || ''}`, icon: 'mdi mdi-circle', iconColor: route.color})
        })

        options.push({value: 'new|#newRoute', title: 'Nieuwe route'})

        Object.values(usersObject).map((user) => {
            options.push({value: `new|${user._id}`, title: `Nieuwe route - ${user.name}`})
        })

        return (
            <Select
                allowEmpty
                style={style}
                label={label}
                value={value}
                options={options}
                disabled={disabled}
                onChange={onChange}
            />
        )
    }
}
